var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33392 6.66663H8.66725V9.99996H7.33392V6.66663ZM7.33325 10.6666H8.66659V12H7.33325V10.6666Z",
    fill: "#FFC814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17855 2.80004C8.94655 2.36337 8.49455 2.09204 7.99988 2.09204C7.50522 2.09204 7.05322 2.36337 6.82122 2.80071L1.92922 12.0427C1.82066 12.2457 1.76689 12.4734 1.7732 12.7035C1.77952 12.9336 1.8457 13.158 1.96522 13.3547C2.08302 13.5523 2.25031 13.7157 2.45058 13.8289C2.65086 13.9421 2.87718 14.0011 3.10722 14H12.8926C13.3646 14 13.7919 13.7587 14.0352 13.3547C14.1545 13.1579 14.2206 12.9335 14.2269 12.7035C14.2332 12.4734 14.1796 12.2457 14.0712 12.0427L9.17855 2.80004ZM3.10722 12.6667L7.99988 3.42471L12.8959 12.6667H3.10722Z",
    fill: "#FFC814"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic_alert.de3e13b1a404704707945d2cee122287.svg";
export { ForwardRef as ReactComponent };